import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { genReportActionTypes } from '../actions/generatedReportActionTypes';

export const REDUCER_NAME = 'GeneratedReports';

const listGeneratedReportActions = (state, action) => {
  switch (action.type) {
    case genReportActionTypes.LIST_GENERATED_REPORT_RESET:
      return {
        ...state,
        generatedReports: null,
        generatedReportsError: null,
      };
    case genReportActionTypes.LIST_GENERATED_REPORT_RESPONSE:
      return {
        ...state,
        generatedReports: action.data,
      };
    case genReportActionTypes.LIST_GENERATED_REPORT_ERROR:
      return {
        ...state,
        generatedReportsError: action.data,
      };

    default:
      return null;
  }
};
const downloadGeneratedReportActions = (state, action) => {
  switch (action.type) {
    case genReportActionTypes.DOWNLOAD_GENERATED_REPORT_RESET:
      return {
        ...state,
        downloadGeneratedReports: null,
        downloadGeneratedReportsError: null,
      };
    case genReportActionTypes.DOWNLOAD_GENERATED_REPORT_RESPONSE:
      return {
        ...state,
        downloadGeneratedReports: action.data,
      };
    case genReportActionTypes.DOWNLOAD_GENERATED_REPORT_ERROR:
      return {
        ...state,
        downloadGeneratedReportsError: action.data,
      };
    default:
      return null;
  }
};

const deleteGeneratedReportActions = (state, action) => {
  switch (action.type) {
    case genReportActionTypes.DELETE_GENERATED_REPORT_RESET:
      return {
        ...state,
        deleteGeneratedReport: null,
        deleteGeneratedReportError: null,
      };
    case genReportActionTypes.DELETE_GENERATED_REPORT_RESPONSE:
      return {
        ...state,
        deleteGeneratedReport: action.data,
      };
    case genReportActionTypes.DELETE_GENERATED_REPORT_ERROR:
      return {
        ...state,
        deleteGeneratedReportError: action.data,
      };
    default:
      return null;
  }
};

const handleShareGenerateReportActions = (state, action) => {
  switch (action.type) {
    case genReportActionTypes.GET_REPORT_SHARE_INFO_RESPONSE:
      return {
        ...state,
        reportShareInfo: action.data,
      };
    case genReportActionTypes.GET_REPORT_SHARE_INFO_ERROR:
      return {
        ...state,
        reportShareInfoError: action.data,
      };
    case genReportActionTypes.SAVE_REPORT_SHARE_INFO_RESPONSE:
      return { ...state,
        saveShareInfoResponse: action.data,
      };
    case genReportActionTypes.SAVE_REPORT_SHARE_INFO_ERROR:
      return { ...state,
        saveShareInfoError: action.data,
      };
    case genReportActionTypes.RESET_REPORT_SHARE_INFO_STORE:
      return { ...state,
        reportShareInfo: null,
        reportShareInfoError: null,
        saveShareInfoResponse: null,
        saveShareInfoError: null,
      };
    default:
      return null;
  }
};

const generateReportActions = (state, action) => {
  switch (action.type) {
    case genReportActionTypes.RESET_GENERATE_REPORT_TEMPLATE_STORE:
      return {
        ...state,
        generateReportResponse: null,
        generateReportError: null,
      };
    case genReportActionTypes.GENERATE_REPORT_TEMPLATE_RESPONSE:
      return {
        ...state,
        generateReportResponse: action.data,
      };
    case genReportActionTypes.GENERATE_REPORT_TEMPLATE_ERROR:
      return {
        ...state,
        generateReportError: action.data,
      };
    default:
      return null;
  }
};

const GeneratedReportsReducer = (state = { ...basicFilterInitialState }, action = null) => {
  const generateReportState = generateReportActions(state, action);
  if (generateReportState) {
    return generateReportState;
  }
  const listState = listGeneratedReportActions(state, action);
  if (listState) {
    return listState;
  }
  const downlaodState = downloadGeneratedReportActions(state, action);
  if (downlaodState) {
    return downlaodState;
  }
  const deleteState = deleteGeneratedReportActions(state, action);
  if (deleteState) {
    return deleteState;
  }
  const shareState = handleShareGenerateReportActions(state, action);
  if (shareState) {
    return shareState;
  }
  return state;
};

export default GeneratedReportsReducer;
